class QueryBuilder {
    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.opts = {
            itemsPerPage: 10,
            page: 1,
        };
    }

    encode(prop, value) {
        return `${encodeURIComponent(prop)}=${encodeURIComponent(value)}`;
    }

    serialize(obj) {
        const str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                if (Array.isArray(obj[p])) {
                    obj[p].forEach(category => {
                        str.push(this.encode(`${p}[]`, category));
                    })
                } else {
                    str.push(this.encode(p, obj[p]));
                }
            }
        return str.join("&");
    }

    setItemsPerPage(limit) {
        this.opts.itemsPerPage = limit;
    }

    setPageIndex(index) {
        this.opts.page = index;
    }

    setPageOrdering(property, order) {
        this.opts[property] = order;
    }

    setSearchString(string) {
        this.opts.search = string;
    }

    setCategory(string) {
        this.opts.category = string;
    }

    setDate(startDate, endDate) {
        this.opts['publishedAt[after]'] = startDate;
        this.opts['publishedAt[before]'] = endDate;
    }

    getQueryString() {
        const serializedData = this.serialize(this.opts);
        this.setDefaults();
        return serializedData;
    }
}

export { QueryBuilder };
